import { defineStore } from 'pinia'
import { fetchSiteData, type SiteData } from '~/queries'
import { useDataCache } from '#nuxt-multi-cache/composables'
import type { Strapline } from '~/schemas'

type State = {
  data: SiteData | null
  straplines: Strapline[] | null
}

export const useSiteStore = defineStore('site', {
  state: (): State => ({
    data: null,
    straplines: null,
  }),
  actions: {
    setSiteData(state: SiteData | null) {
      this.data = state
    },
    setStraplines(straplines: Strapline[] | null) {
      this.straplines = straplines
    },
    async fetch(revalidate: boolean = false) {
      if (this.data && !revalidate) return this.data

      const { siteId } = useSite().site.value
      const app = useNuxtApp()

      try {
        const { value, addToCache } = await useDataCache('site-data', app.ssrContext?.event)
        if (value && !revalidate) {
          this.data = value;
        } else {
          this.data = await app.runWithContext(() => fetchSiteData({ siteId }))
          await addToCache(this.data)
        }

        return this.data
      } catch (error) {
        throw createError({
          statusCode: 500,
          statusMessage: 'Error fetching site data',
        })
      }
    },
  },
})
